module.exports = __webpack_public_path__ + "img/four.1d720aec.png";